
import styled, { css } from 'styled-components';
import breakpoint, { map } from 'styled-components-breakpoint';


export const Card = styled.div`
    display: flex; 
    flex-direction: column;
    width: 100%;
    height: 100%;
    background-color: #fff;
    border-radius: 3px;
    padding: 2rem 0;
    box-shadow: 0 .5rem .5rem rgba(0,0,0, .11);
    position: relative;
    padding: 3rem 4rem;

    &::before{
        content: "\\201C"; 
        font-size: 20rem;
        position: absolute;
        top: -2.75rem;
        left: -1rem;  
        color: rgba(119, 119, 119, 0.11);
        font-family: sans-serif;
        line-height: 1 ;

        z-index: 1;
    }

`


export const Wrapper = styled.div`

    flex:1;
    display:flex;
    align-self: flex-end;
    align-items: center;
    margin-top: 2rem;
`

export const Pic = styled.img`    
    height:5rem;
    width:5rem;
    border-radius: 50%;
    margin-right: 1.5rem;
`

export const Name = styled.p`


`